import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { TrackByValue, XuxGridActionPayload } from '@app/shared/types';
import { IDropdownMenuOption } from '@app/shared/types/ui';
import { trackByValue } from '@app/shared/utils/common-utils';
import {
  HorizontalPosition,
  VerticalPosition,
} from '@geniuspos/ui-shared/modules/xdm-shared-components/definitions/types/dropdown.type';
import { DropdownMenuService } from '@geniuspos/ui-shared/modules/xdm-shared-service/dropdown-menu/dropdown-menu.service';
import { ICellRendererParams } from 'ag-grid-community';
import { isFunction } from 'lodash';
import { BaseArrayStringRendererMenuComponent } from './base-array-string-renderer-menu/base-array-string-renderer-menu.component';

@Component({
  selector: 'xvi-base-array-string-renderer',
  templateUrl: './xvi-base-array-string-renderer.component.html',
  styleUrls: ['./xvi-base-array-string-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XviBaseArrayStringRendererComponent implements OnDestroy {
  @Input() public stringValue: string = '';
  @Input() public items: IDropdownMenuOption[] = [];
  @Input() public wrapperClass: string = '';
  @Input() public allButton: string = '';
  @Input() public itemClass: string = '';
  @Input() public params: ICellRendererParams;
  @Input() public linkClick: (event: XuxGridActionPayload) => Promise<void>;
  @Output() public dropdownMenuClick: EventEmitter<{
    option: IDropdownMenuOption;
  }> = new EventEmitter<{ option: IDropdownMenuOption }>();

  public trackByValue: TrackByValue = trackByValue;

  public constructor(private dropDownMenuService: DropdownMenuService) {}

  public showDropdown(event: MouseEvent): void {
    this.dropDownMenuService.createComponent(
      BaseArrayStringRendererMenuComponent,
      {
        options: this.items,
        wrapperClass: this.wrapperClass,
        trackByValue: this.trackByValue,
        dropdownMenuClick: this.dropdownMenuClick,
      },
      event.currentTarget as HTMLElement,
      HorizontalPosition.RIGHT,
      VerticalPosition.BOT,
    );
    event.stopPropagation();
  }

  public ngOnDestroy(): void {
    this.dropDownMenuService.clearContainer();
  }

  public clickString(): void {
    if (isFunction(this.linkClick)) {
      this.linkClick({
        value: this.items,
      });
    }
  }
}
